import { createJSONRequest } from './create-request.js'

/**
 * An actor's transition claims.
 *
 * The GET returns every transition configured for the ecosystem, not only the answered ones, so
 * the profile wizard can ask about the rest. Each entry carries the winning claim plus the
 * competing claims per source — our classification and the actor's own declaration coexist, and
 * the declaration only outranks the suggestion once it is substantiated.
 */
export const fetchActorTransitions = (actorId) => createJSONRequest({
  url: `/api/actors/${actorId}/transitions`,
  method: 'GET',
})

/**
 * Save the actor's own answers. Always stored as `actor_input` server-side — the front-end
 * cannot write a classification, just as the AI stack cannot write a declaration.
 */
export const updateActorTransitions = (actorId, transitions) => createJSONRequest({
  url: `/api/actors/${actorId}/transitions`,
  method: 'PUT',
  data: { transitions },
})
